const toggleMap = {
  listBtn: document.getElementById('jsListBtn') as HTMLElement,
  mapBtn: document.getElementById('jsMapBtn') as HTMLElement,
  mapWrap: document.getElementById('jsMapWrap') as HTMLElement,

  init() {
    this.setList();
    this.setMap();
  },

  setList() {
    if (this.listBtn) {
      this.listBtn.addEventListener('click', () => {
        this.mapWrap.classList.remove('activeClass');
        this.mapBtn.classList.remove('activeClass');
        this.listBtn.classList.remove('activeClass');
      });
    }
  },

  setMap() {
    if (this.mapBtn) {
      this.mapBtn.addEventListener('click', () => {
        this.mapWrap.classList.add('activeClass');
        this.mapBtn.classList.add('activeClass');
        this.listBtn.classList.add('activeClass');
      });
    }
  },
};

export default toggleMap;
